import store from 'app/redux/store/store'
import { sobrescreverInformacoesAction } from 'app/redux/orcamentoSlice';
import { Orcamento } from "app/models/orcamento/orcamento";
import { definirDespesasInclusas } from "app/use-cases/orcamento/definirDespesasInclusas";
import { definirPercentualDescontoAcumulado } from "app/use-cases/orcamento/definirPercentualDescontoAcumulado";
import { definirPercentualSeguroEntrega } from "app/use-cases/orcamento/definirPercentualSeguroEntrega";
import { definirValorFrete } from "app/use-cases/orcamento/definirValorFrete";
import { ControllerBase } from "controllerBase";
import { parametroSistema } from "../parametros/parametroController";
import global from 'globalMU'
import * as totalizadorActions from 'app/redux/totalizadorSlice'
import { removerTodosComponentesReactDoConteudoPrincipal, renderizarComponentReact } from 'app/components/renderizarOuRemoverComponentReact';
import { definirValorSeguroEntrega } from 'app/use-cases/orcamento/definirValorSeguroEntrega';
import { removerBreadcrumb2, removerBreadcrumbOriginal } from 'app/components/breadcrumb2/breadcrumb2Utils';
import { TelaFormaDePagamentoContainer } from 'app/components/formas-de-pagamento/TelaFormaDePagamentoContainer';
import { TelaComissoesContainer } from 'app/components/comissoes/TelaComissoesContainer';
import { GridEnderecosContainer } from 'app/components/enderecosOrcamento/GridEnderecosOrcamentoContainer';
import { FretePorPesoCubagemContainer } from 'app/components/frete-por-peso-cubagem/FretePorPesoCubagemContainer';
import { obterParametro } from 'app/use-cases/parametro/obterParametro';
import React from 'react';
import { FinalizarOrcamentoContainer } from 'app/components/finalizar-orcamento/FinalizarOrcamentoContainer';
import { TelaEntregaContainer } from "../../components/entrega/TelaEntregaContainer";
import { DestinoTransferenciaContainer } from "../../components/destinoTransferencia/DestinoTransferenciaContainer";
import { CotacoesPerdidasContainer } from 'app/components/cotacoes-perdidas/CotacoesPerdidasContainer';
import { AutorizadoContainer } from 'app/components/autorizado/AutorizadoContainer';
declare var window: any
import { FaturamentoContainer } from 'app/components/faturamento/FaturamentoContainer';
import { ResumoOrcamentoContainer } from 'app/components/resumo/ResumoOrcamentoContainer';
import { DescontosContainer } from 'app/components/descontos/DescontosContainer';
import { TelaMarkupContainer } from 'app/components/markup/TelaMarkupContainer';
import { PesquisarClienteContainer } from 'app/components/pesquisa-cliente/PesquisarClienteContainer';
import { ItensOrcamentoContainer } from 'app/components/itens-orcamento/ItensOrcamentoContainer';
import { verificarRecuperarOrcamentoNaoGravado } from 'app/components/itens-orcamento/useRecuperarOrcamentoEmAndamento';
import globalMU from 'globalMU';
import microuniversoApi from 'app/api/microuniversoApi';
import { PaginaPesquisaProdutoContainer } from 'app/components/pesquisa-produtos/PaginaPesquisaProdutoContainer';
import { Dict } from 'app/utils/Dict';
import { gravarTelasAlteradasSalvaAction } from 'app/redux/telaOrcamentoAlteradaNaoSalvaSlice';
import { DespesasOrcamentoContainer } from 'app/components/DespesasOrcamento/DespesasOrcamentoContainer';
import { MicrouniversoApi } from 'app/api/classes/MicrouniversoApi';
import escape from "lodash/escape";


declare var window: any
declare var PesquisarClientesController: any
declare var DescontosController: any
declare var FormaPagamentoController: any
//declare var FinalizarOrcamentoController: any
declare var EnderecoOrcamentoController: any
declare var PesquisarCotacoesPerdidasController: any
declare var MarkupOrcamentoController: any
declare var PesquisarIndicadorOrcamentoController: any
declare var AutorizadoOrcamentoController: any
declare var ResumoOrcamentoController: any
declare var EntregaOrcamentoController: any
declare var FreteOrcamentoController: any
declare var TipoEntregaOrcamentoController: any
declare var faturamentoOutrasSaidasController: any
declare var AsideDireita: any

const OrcamentoController = ControllerBase.extend({
    name: "OrcamentoController",
    menuInicial: "item-venda",
    initialize: function () {
        this.atacharEventos();
    },


    iniciarModel: async function (orcamento) {
        
        if (!orcamento) {
            return;
        }

        this.model = new Orcamento(orcamento);

        this.model.on('change', () => {
            window.alert('Atualizações no estado legado nao sao mais permitidas, isto é um erro. Informações foram gravadas no console do browser')
            console.trace('alteracao detectada no orcamento legado')
        })

        await this.verificarPendenciaVendaFrete()
        await this.verificarPendenciaFormaDePagamento()

    },

    iniciar: async function (orcamento, menuInicialFavorito) {
        
        if (!orcamento) {
            return;
        }

        if (orcamento.Numero > 0) {
            store.dispatch(sobrescreverInformacoesAction({
                OrcamentoExistenteSendoAbertoParaEdicaoOuConsulta: true
            }))
        }

        this.model = {}

        this.iniciarModel(orcamento);
        //this.start();
        // global.sessionStorage.removeData('ItensSemOrdenacao');
        if (globalMU.isNotNullOrEmpty(menuInicialFavorito)) {
            this.menuInicial = menuInicialFavorito
        }


        this.ativarMenuInicialFavorito();

        // 482572 — chamada direta (fora de React): o menu inicial favorito (estrela, ver
        // ativarMenuInicialFavorito acima) pode abrir em qualquer aba, não só Itens/Pesquisar
        // Produtos — as únicas que chamam o hook useRecuperarOrcamentoEmAndamento. Sem esta
        // chamada aqui, abrir direto numa aba diferente (Cliente, Forma de Pagamento...) nunca
        // oferece a recuperação de um orçamento não gravado. Guard de módulo em
        // useRecuperarOrcamentoEmAndamento.ts evita pergunta duplicada se a aba favorita for uma
        // das duas que também chamam o hook.
        verificarRecuperarOrcamentoNaoGravado(orcamento);

        if (parametroSistema.obter("FRETE_PERCENTUAL_NO_ORCAMENTO").Valor === "S"   // 445689
            && (
                parametroSistema.obter("FRETE_POR_ROTEIRO_ORCAMENTO").Valor === "S"
                || parametroSistema.obter("TRATAMENTO_PERCENTUAL_FRETE_POR_ROTEIRO").Valor === "S"
                || parametroSistema.obter("UTILIZA_ROTEIRO_POR_FAIXA_CEP").Valor === "S"

            )
        ) { // 445689
            global.showErrorMessage("Para que o parâmetro [Permitir informar frete percentual no orçamento] funcione, os parâmetros abaixo devem estar desligados: <br>- Tratamento de percentual do frete por roteiro <br>- Tratamento de valor do frete por roteiro<br>- Utiliza roteiro por faixa de CEP");
        }

        // FNX-4631
        var diasPrevisaoEntrega = parametroSistema.obter("DIAS_UTEIS_PREVISAO_ENTREGA_ORCAMENTO");
        var numMaxDias = parametroSistema.obter("DIAS_MAXIMO_PREVISAO_ENTREGA");

        //FNX-6155
        var utilizaRecursoAmbientesPorFilial = parametroSistema.obter("AMBIENTE_ORCAMENTO_POR_FILIAL")?.Valor;
        if (utilizaRecursoAmbientesPorFilial === "" || utilizaRecursoAmbientesPorFilial === null) {
            utilizaRecursoAmbientesPorFilial = parametroSistema.obter("AMBIENTE_ORCAMENTO").Valor;
        }
        if (!utilizaRecursoAmbientesPorFilial || utilizaRecursoAmbientesPorFilial === null)
            utilizaRecursoAmbientesPorFilial = "";
        var utilizaRecursoAmbiente = utilizaRecursoAmbientesPorFilial?.toUpperCase() === "S";


        if (parseInt(numMaxDias.Valor) > 0 && parseInt(numMaxDias.Valor) < (parseInt(diasPrevisaoEntrega.Valor) + 4))
            global.showErrorMessage("Atenção: <BR>Parâmetro \"Número máximo de dias para a previsão de entrega\" deve ser pelo menos 4 dias a mais do que o parâmetro \"Número de dias úteis para previsão de entrega do orçamento\"<br><br>- Número máximo de dias para a previsão de entrega: " + numMaxDias.Valor + "<br>- Número de dias úteis para previsão de entrega do orçamento: " + diasPrevisaoEntrega.Valor);
        numMaxDias = parametroSistema.obter("DIAS_MAXIMO_PREVISAO_ENTREGA_ENCOMENDA");
        if (parseInt(numMaxDias.Valor) > 0 && parseInt(numMaxDias.Valor) < (parseInt(diasPrevisaoEntrega.Valor) + 4))
            global.showErrorMessage("Atenção: <BR>Parâmetro \"Número máximo de dias para a previsão de entrega de encomenda\" deve ser pelo menos 4 dias a mais do que o parâmetro \"Número de dias úteis para previsão de entrega do orçamento\"<br><br>- Número máximo de dias para a previsão de entrega de encomenda: " + numMaxDias.Valor + "<br>- Número de dias úteis para previsão de entrega do orçamento: " + diasPrevisaoEntrega.Valor);

        // if (parametroSistema.obter("CUSTO_PARA_GERAR_MARKUP").Valor === "28889" && parametroSistema.obter("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO").Valor === "S" && parametroSistema.obter("DESABILITAR_PAGINA_ORDEM_SEPARACAO_CONFERENCIA_SAIDA").Valor === "S") { /*é papelaria*/
        //     if (parametroSistema.obter("PRODUTO_COM_PRECOS_DIFERENTES_MESMO_ORCAMENTO").Valor === "S" && utilizaRecursoAmbiente) // FNX-6155
        //         global.showInfoMessage("Para o correto funcionamento do sistema, o parâmetro \"Utilizar recurso de  ambientes no orçamento\" deve estar desabilitado") /*FNX-4253*/
        // }

        /* 473440 pa 471187
                const rawFiliaisAutorizadas = globalMU.sessionStorage.getData('UsuarioLogado').FiliaisAutorizadasOid.replace(/&quot;/g, '"')
                const listFiliaisAutorizadas = JSON.parse(`[${rawFiliaisAutorizadas}]`); 
                parametroSistema.obter("FILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL",(filialParam) => {
                    if (globalMU.isNullOrEmpty(filialParam.Valor) || store.getState().orcamento.TipoOrcamentoDescricao != "Venda")
                        return;
                    const filialValidar = filialParam.Valor && !isNaN(Number(filialParam.Valor)) ? Number(filialParam.Valor) : null;
                    if (filialValidar > 7 && !listFiliaisAutorizadas.includes(filialValidar))
                    {
                        new MicrouniversoApi().Orcamento.obterFilialPorOid(filialValidar).then(filial => {
                            
                            global.showWarnMessage(`Atenção: <BR>O parâmetro |Filial de transferência para venda futura com retirada local|, configurado com o valor [<span>${escape(filial.Nome)}</span>], possui uma filial informada não autorizada para o usuário, por este motivo este recurso não foi ativado.`);
                        });
                    }
                })
                */


        if (store.getState().orcamento.TipoOrcamentoDescricao == "Venda")// 473440 pa 471187
        {
            const paramPERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA = parametroSistema.obter("PERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA").Valor || "N" //471187

            //if (paramPERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA == "S")// 473440 pa 471187
            //{

            const paramFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL = parametroSistema.obter("FILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL").Valor || "0" //471187
            const oidFilialValidar = paramFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL && !isNaN(Number(paramFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL))
                ? Number(paramFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL)
                : 7;


            if (oidFilialValidar > 7 && paramPERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA == "S") // 473440 pa 471187
            {
                global.showErrorMessage(`Parâmetros ativados simultaneamente!<BR><BR>Os recursos foram ignorados.<BR>Um destes parâmetros deve ser desativado.<br><br>Parâmetros:<BR>- Permite venda com retirada local e transferência<BR>- Filial de transferência para venda futura com retirada local`);

            }
            if (oidFilialValidar > 7 || paramPERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA == "S") // 473440 pa 471187 / 487888
            {
                const rawFiliaisAutorizadas = globalMU.sessionStorage.getData('UsuarioLogado')?.FiliaisAutorizadasOid?.replace(/&quot;/g, '"') || '' // 492000
                const listFiliaisAutorizadas = JSON.parse(`[${rawFiliaisAutorizadas}]`);
                if (oidFilialValidar > 7 && !listFiliaisAutorizadas.includes(oidFilialValidar)) {// 473440 pa 471187
                    new MicrouniversoApi().Orcamento.obterFilialPorOid(oidFilialValidar).then(filial => {

                        global.showWarnMessage(`Atenção: <BR>O parâmetro |Filial de transferência para venda futura com retirada local|, configurado com o valor [<span>${escape(filial.Nome)}</span>], possui uma filial informada não autorizada para o usuário, por este motivo este recurso não foi ativado.`);
                    });
                }
            }
            //}
        }

        const self = this

        if (store.getState().orcamento.TipoOrcamentoDescricao == "Venda" && (await obterParametro({ nome: "TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM" })) == "S") {
            self.mostrarMenuFretePesoOuCubagem()
        } else {
            self.esconderMenuFretePesoOuCubagem()
        }

        store.subscribe(() => {
            if (store.getState().orcamento.AptoParaGestaoDeFretes) {
                self.ativarMenuFretePesoOuCubagem()
            } else {
                self.desativarMenuFretePesoOuCubagem()
            }

            self.mostrarNomeCliente()
        })

        store.dispatch(sobrescreverInformacoesAction({
            OrcamentoExistenteSendoAbertoParaEdicaoOuConsulta: false
        }))
    },

    verificarPendenciaVendaFrete: async function () {
        const existePendenciaVendaFrete = await microuniversoApi.Orcamento.VerificarPendenciaVendaFrete()

        if (existePendenciaVendaFrete) {
            store.dispatch(sobrescreverInformacoesAction({ CalcularFreteAutomaticamente: true, VerificarPendenciaVendaFrete: true }))
        }
    },

    verificarPendenciaFormaDePagamento: async function () {
        const existePendenciaFormaPagamento = await microuniversoApi.Orcamento.VerificarPendenciaFormaDePagamento()

        if (existePendenciaFormaPagamento) {
            store.dispatch(sobrescreverInformacoesAction({ VerificarPendenciaFormaDePagamento: true }))
        }
    },

    mostrarMenuFretePesoOuCubagem: function () {
        document.getElementById("itemMenuFretePesoCubagem").style.display = "block"
    },

    esconderMenuFretePesoOuCubagem: function () {
        document.getElementById("itemMenuFretePesoCubagem").style.display = "none"
    },

    ativarMenuFretePesoOuCubagem: function () {
        // document.getElementById("orcamento_menu_frete_peso_cubagem").style.color = "#333739"
        if (document.getElementById("orcamento_menu_frete_peso_cubagem") != null) {
            document.getElementById("orcamento_menu_frete_peso_cubagem").getElementsByClassName("fa-shipping-fast")?.[0]?.classList?.add?.("icone2-frete-peso-cubagem-ativado")
            document.getElementById("orcamento_menu_frete_peso_cubagem").getElementsByClassName("fa-shipping-fast")?.[0]?.classList?.remove("icone2-frete-peso-cubagem-desativado")
            document.getElementById("orcamento_menu_frete_peso_cubagem").style.cursor = "pointer"
        }
    },

    desativarMenuFretePesoOuCubagem: function () {
        // document.getElementById("orcamento_menu_frete_peso_cubagem").style.color = "#bbb"
        if (document.getElementById("orcamento_menu_frete_peso_cubagem") != null) {
            document.getElementById("orcamento_menu_frete_peso_cubagem")?.getElementsByClassName?.("fa-shipping-fast")?.[0]?.classList?.remove?.("icone2-frete-peso-cubagem-ativado")
            document.getElementById("orcamento_menu_frete_peso_cubagem")?.getElementsByClassName?.("fa-shipping-fast")?.[0]?.classList?.add?.("icone2-frete-peso-cubagem-desativado")
            document.getElementById("orcamento_menu_frete_peso_cubagem").style.cursor = "default"

        }

    },


    atacharEventos: function () {
        
        $("[item-menu]").click($.proxy(this.itemMenuSelecionado, this));
        //$(document).keydown($.proxy(this.tratarAtualizacaoPagina, this));
        $(window).on("beforeunload", $.proxy(this.tratarVoltarPagina, this));
        //$(window).on("unload", $.proxy(this.sair, this));
        $("body").on("contextmenu", $.proxy(this.desligarMenu, this));
        $("#valor-despesas-inclusas").change($.proxy(this.definirDespesasInclusas, this, false));
        $("#valor-despesas-inclusas").keypress($.proxy(this.definirDespesasInclusas, this, true));
        $("#percentual-desconto").change($.proxy(this.percentualDescontoAlterado, this, false));
        $("#percentual-desconto").keypress($.proxy(this.percentualDescontoAlterado, this, true));
        $("#valor-desconto").change($.proxy(this.valorDescontoAlterado, this, false));
        $("#valor-desconto").keypress($.proxy(this.valorDescontoAlterado, this, true));
        //
        $("#percentual-desconto-nacional").change($.proxy(this.percentualDescontoNacionalAlterado, this, false)); // FNX-5558
        $("#percentual-desconto-nacional").keypress($.proxy(this.percentualDescontoNacionalAlterado, this, true));// FNX-5558

        $("#valor-desconto-nacional").change($.proxy(this.valorDescontoNacionalAlterado, this, false));// FNX-5558
        $("#valor-desconto-nacional").keypress($.proxy(this.valorDescontoNacionalAlterado, this, true));// FNX-5558

        $("#percentual-desconto-importado").change($.proxy(this.percentualDescontoImportadoAlterado, this, false));// FNX-5558
        $("#percentual-desconto-importado").keypress($.proxy(this.percentualDescontoImportadoAlterado, this, true));// FNX-5558

        $("#valor-desconto-importado").change($.proxy(this.valorDescontoImportadoAlterado, this, false));// FNX-5558
        $("#valor-desconto-importado").keypress($.proxy(this.valorDescontoImportadoAlterado, this, true));// FNX-5558
        //
        $("#percentual-desconto-acumulado").change($.proxy(this.percentualDescontoAcumuladoAlterado, this, false));
        $("#percentual-desconto-acumulado").keypress($.proxy(this.percentualDescontoAcumuladoAlterado, this, true));
        $("#valor-desconto-acumulado").change($.proxy(this.valorDescontoAcumuladoAlterado, this, false));
        $("#valor-desconto-acumulado").keypress($.proxy(this.valorDescontoAcumuladoAlterado, this, true));
        $("#valor-acrescimo-financeiro").change($.proxy(this.valorAcrescimoFinanceiroAlterado, this, false));
        $("#valor-acrescimo-financeiro").keypress($.proxy(this.valorAcrescimoFinanceiroAlterado, this, true));
        $("#percentual-seguro-entrega").change($.proxy(this.percentualSeguroAlterado, this, false));
        $("#percentual-seguro-entrega").keypress($.proxy(this.percentualSeguroAlterado, this, true));
        $("#valor-seguro-entrega").change($.proxy(this.valorSeguroAlterado, this, false));
        $("#valor-seguro-entrega").keypress($.proxy(this.valorSeguroAlterado, this, true));
        $("#valor-frete").change($.proxy(this.valorFreteAlterado, this, false));
        $("#valor-frete").keypress($.proxy(this.valorFreteAlterado, this, true));
        $("[menu-inicial-favorito]").click($.proxy(this.alterarMenuInicialFavorito, this));

        $("input").on('focus', function () { $(this).select(); });

        const self = this


    },

    desligarMenu: function () {
        return false;
    },
    flagOrcamentoFinalizado: false,
    tratarVoltarPagina: function (event: any) {
        //sessionStorage.clear();
        /*
        Comentado até entender quais devem realmente ser limpados
        */
        const params = new URLSearchParams(window.location.search);
        sessionStorage.setItem('aba_id', params.get('XAbaId') || '');


        // 458014 var permitirSairView = $(window).attr("permitirSairView");
        // 458014 if (permitirSairView !== undefined && permitirSairView) {
        // 458014      return;
        // 458014 }
        // 458014 if (this.model && this.model.get("SomenteLeitura")) {
        // 458014     return;
        // 458014 }
        // 458014 if (this.finalizarOrcamentoController) {
        // 458014     if (this.finalizarOrcamentoController.container) {
        // 458014         if (this.finalizarOrcamentoController.currentRegion && this.finalizarOrcamentoController.currentRegion.name === "numeroPedidoViewRegion") {
        // 458014             this.flagOrcamentoFinalizado = true;
        // 458014         }
        // 458014     }
        // 458014 }

        // 458014 if (this.model && !this.flagOrcamentoFinalizado) {
        // 458014     return "Atenção, o orçamento iniciado será perdido, deseja continuar?";
        // 458014 }
        let sair = false
        let somenteLeitura = false

        const numeroPedidoEditando = store.getState?.()?.orcamento?.Numero ?? undefined // 458014
        if (numeroPedidoEditando != undefined)
            somenteLeitura = store.getState().orcamento.SomenteLeitura
        if (numeroPedidoEditando != undefined && !somenteLeitura && store.getState()?.orcamento?.ItensOrcamento?.length > 0 && globalMU.existeOrcamentoEmAndamento()) {

            const orcamentoConcluido = sessionStorage.getItem('orcamentoConcluido') == "true" //467485
            if (!orcamentoConcluido) {
                const mensagem = `Existe um orçamento em andamento, se prosseguir este orçamento será perdido. Continuar?`
                // 491123 — handlers registrados via $(window).on(...) usam addEventListener por baixo;
                // navegadores modernos exigem event.returnValue (ou preventDefault()) explícito para
                // exibir o diálogo nativo de beforeunload — apenas retornar a string (como antes) é
                // ignorado nesse caso (só funciona para o atributo legado window.onbeforeunload).
                const eventoNativo = event?.originalEvent ?? event
                if (eventoNativo) {
                    eventoNativo.preventDefault?.()
                    eventoNativo.returnValue = mensagem
                }
                return mensagem
            }

        }

        return
    },

    sair: function () {
        /*
        if (this.model) {
            
            var numeroPedido = this.model.get("Numero"); // FNX-4975
            var somenteLeitura = this.model.get("SomenteLeitura"); // FNX-4975
            var identificadorOrcamento = this.model.get("IdentificadorOrcamento");
            452758 e 446116--global.ajax({  // FNX-3979
                url: "/Orcamento/LiberarOrcamentoAoSair",
                blockUI: false,
                type: "post",
                contentType: "application/json",
                data: global.toJSONString({
                    identificadorOrcamento: identificadorOrcamento,
                }),
                success: function (data) {

                    if (!data) {
                        global.unblockUI();
                        return;
                    }
                },

            });


            452758 e 446116-- if (!somenteLeitura && numeroPedido > 0 && navigator.userAgent.match(/Chrome/)) { // FNX-4975
                global.ajax({  // FNX-4975
                    url: "/Comum/ExcluirRegistroPendenteOrcamento",
                    blockUI: false,
                    type: "post",
                    contentType: "application/json",
                    data: global.toJSONString({
                        numPedido: numeroPedido,
                    }),
                }); // FNX-4975
            }
            
            this.model.sair();

        }
            */
    },

    tratarAtualizacaoPagina: function (e) {
        
        if (!((e.which || e.keyCode) === 116)) {
            return;
        }
        if (typeof this.model === "undefined" || !this.model) {
            return;
        }
        if (!global.confirm("Atenção, o orçamento iniciado será perdido, deseja continuar?")) {
            e.preventDefault();
        }
    },

    mostrarAsideDireita: function (e) {
        if ($(e.target).hasClass("ativo")) {
            $(e.target).removeClass("ativo");
            $("aside").hide();
            $("aside").addClass("none");
        } else {
            $(e.target).addClass("ativo");
            $("aside").show();
            $("aside").removeClass("none");
        }
    },

    alterarMenuInicialFavorito: function (e) {
        var elementosMenu = $("[menu-inicial-favorito]");
        elementosMenu.removeClass("icone-estrela-cheia");
        elementosMenu.addClass("icone-estrela-vazia");
        $(e.target).addClass("icone-estrela-cheia");
        this.menuInicial = $(e.target).attr("menu-inicial-favorito");

        var self = this;

        global.ajax({
            url: '/Usuario/MenuInicialFavorito',
            type: 'post',
            data: { menu: self.menuInicial }
        });
    },

    ativarMenuInicialFavorito: function () {
        var elemento = $("[item-menu=" + this.menuInicial + "]");
        this.itemMenuSelecionado(elemento);
        $("[menu-inicial-favorito=" + this.menuInicial + "]").addClass("icone-estrela-cheia");
    },

    validarPrecisaSalvarResumo: function () { // FNX-4901
        if (!window.confirm('Dados foram alterados e não foram aplicados!\n\nDeseja descartar alteração?')) {
            var $salvarResumo = $("#salvar-orcamento");
            if ($salvarResumo && $salvarResumo.is(':visible')) {
                $salvarResumo.focus();
                return false; // FNX-4901
            }
        }
        return true;
    },

    // Extraído de itemMenuSelecionado para ser reutilizável por navegações que não passam pelo menu
    // lateral (ex: botão flutuante da cesta de produtos em _BaseInterno.cshtml, via window.orcamentoController)
    podeDescartarAlteracoesTelaAtual: function () {
        if (Object.keys(store.getState().telaOrcamentoAlteradaNaoSalva).length > 0 || this.model.itemMenu === "entrega-orcamento" && (this.model.DadosAlteradosEntrega["entrega"] || this.model.DadosAlteradosEntrega["transportadora"] || this.model.DadosAlteradosEntrega["frete"] || this.model.DadosAlteradosEntrega["editartipoentrega"])) {
            if (!confirm('Dados foram alterados e não foram aplicados!\n\nDeseja descartar alteração?')) {
                return false;
            }
            store.dispatch(gravarTelasAlteradasSalvaAction(""))
        }

        if (this.model.itemMenu && this.model.itemMenu === "resumo-orcamento" && this.model.DadosAlterados && !this.model.get("SomenteLeitura") && !this.validarPrecisaSalvarResumo()) // FNX-4901
            return false;

        return true;
    },

    itemMenuSelecionado: function (e) {

        // if (!this.validateBeforeToContinue())
        //     return;

        if (!this.podeDescartarAlteracoesTelaAtual())
            return false;



        var target = $(e);
        if (e.target)
            target = $(e.target);

        var itemMenuCliqueDireto = target.attr("item-menu");
        var itemMenu = itemMenuCliqueDireto || target.parent().attr('item-menu');

        // 491123 — bloqueia "Finalizar" enquanto existem produtos selecionados na cesta ainda não
        // incluídos no orçamento: finalizar sem resolver isso faria esses produtos desaparecerem
        // silenciosamente (nunca chegam a fazer parte do pedido salvo). Abre a mesma cesta usada
        // pelo botão flutuante (sem sair da tela atual) para o usuário decidir: incluir os itens
        // ou esvaziar o carrinho. Feito antes de mexer na classe "ativo" do menu — se bloqueado,
        // o item "Finalizar" não deve ficar marcado como ativo (a tela não mudou de fato).
        if ((itemMenu === "finalizar-orcamento" || itemMenu === "finalizar-orcamento-react")
            && (store.getState().produtosSelecionados.produtos || []).length > 0) {
            globalMU.showWarnMessage("Existem produtos selecionados na cesta que ainda não foram incluídos no orçamento.<br/><br/>Inclua os produtos ou esvazie a cesta para poder finalizar o orçamento.")
            window.abrirModalCestaProdutosSemNavegar && window.abrirModalCestaProdutosSemNavegar()
            return false;
        }

        $("[item-menu]").parent().removeClass("ativo");

        if (itemMenuCliqueDireto) {
            target.parent().addClass("ativo");
        } else {
            target.parent().parent().addClass("ativo");
        }

        switch (itemMenu) {
            case "cliente":
                this.renderizarViewClienteReact();
                break;
            case "cliente-react":
                this.renderizarViewClienteReact();
                break;
            case "descontos":
                this.renderizarViewDescontosReact();
                break;
            case "descontos-react":
                this.renderizarViewDescontosReact()
                break;
            case "forma-pagamento":
                this.renderizarViewFormaPagamentoReact();
                break;
            case "item-venda":
                this.renderizarViewItemVenda();
                break;
            case "markup-orcamento":
                this.renderizarViewMarkupReact();
                break;
            case "markup-orcamento-react":
                this.renderizarViewMarkupReact();
                break;
            case "indicador-orcamento":
                this.renderizarViewIndicadores();
                break;
            case "entrega-orcamento":
                this.renderizarViewEntregaOrcamentoReact();
                break;
            case "entrega-orcamento-react":
                this.renderizarViewEntregaOrcamentoReact();
                break;
            case "frete-orcamento":
                this.renderizarViewFreteOrcamento();
                break;
            case "tipo-entrega-orcamento":
                this.renderizarViewTipoEntregaOrcamento();
                break;
            case "finalizar-orcamento":
                this.renderizarViewFinalizarOrcamentoReact();
                break;
            case "finalizar-orcamento-react":
                this.renderizarViewFinalizarOrcamentoReact();
                break;
            case "despesas-orcamento": // 440122
                this.renderizarViewDespesas()// 440122
                break
            case "autorizado-orcamento":
                this.renderizarViewAutorizadoOrcamentoReact();
                break;
            case "autorizado-orcamento-react":
                this.renderizarViewAutorizadoOrcamentoReact();
                break;
            case "resumo-orcamento":
                this.renderizarViewResumoReact();
                break;
            case "resumo-orcamento-react":
                this.renderizarViewResumoReact();
                break;
            case "enderecos-orcamento":
                this.renderizarViewEnderecosReact();
                break;
            case "cotacoes-perdidas-orcamento":
                this.renderizarCotacoesPerdidasReact();
                break;
            case "cotacoes-perdidas-orcamento-react":
                this.renderizarCotacoesPerdidasReact()
                break;
            case "faturamento-outras-saidas":
                this.renderizarFaturamentoOutrasSaidasReact();
                break;
            case "faturamento-outras-saidas-react":
                this.renderizarFaturamentoOutrasSaidasReact();
                break;
            case "destino-transferencia":
                this.renderizarViewDestinoTransferenciaReact();
                break;
            case "destino-transferencia-react":
                this.renderizarViewDestinoTransferenciaReact();
                break;
            case "forma-pagamento-react":
                this.renderizarViewFormaPagamentoReact()
                break;
            case "comissoes":
                this.renderizarViewComissoesReact()
                break;
            case "comissoes-react":
                this.renderizarViewComissoesReact()
                break;
            case "enderecos-orcamento-react":
                this.renderizarViewEnderecosReact()
                break;

            case "frete-peso-cubagem":
                this.renderizarViewFretePesoCubagem()
                break;
        }
        //this.mostrarNomeCliente();


        // FNX-4901 - Codigo abaixo deve ser o último do metodo
        this.model.itemMenu = itemMenu; // FNX-4901
        this.model.DadosAlterados = false;
        this.model.DadosAlteradosEntrega = [];
    },

    ajustarOpcaoDoOrcamento: function (model, orcamento, prefixo) {
        var $grupo = $("#" + prefixo + "GrupoOpcaoOrcamento");

        if (!orcamento.get("SomenteLeitura") && orcamento.get("CodigoDAV") !== "") {
            $grupo.find(":radio").prop('read-only', "ignore");
            $grupo.find(":radio").prop("disabled", false);
        }

        var situacoes = model.Situacoes();
        var situacaoAtual = orcamento.get("Situacao");
        $grupo.find(":radio").prop('checked', false)
        if (situacoes !== null) {
            $.each(situacoes, function () {
                if (this.Codigo() === 6) {
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_LabelApenasOrcamento").show();
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_ApenasOrcamento").show();
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_ApenasOrcamento").prop('checked', situacaoAtual === 6);
                }
                if (this.Codigo() === 5) {
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_LabelEnviarSupervisao").show();
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_EnviarSupervisao").show();
                    $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_EnviarSupervisao").prop('checked', situacaoAtual === 5);
                }
                if (this.Codigo() === 1) {
                    if (this.Descricao().toUpperCase() === "APENAS CONFIRMADO") {
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_LabelApenasConfirmado").show();
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_ApenasConfirmado").show();
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_ApenasConfirmado").prop('checked', situacaoAtual === 1);
                    }
                    if (this.Descricao().toUpperCase() === "ORÇAMENTO CONFIRMADO") {
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_LabelOrcamentoConfirmado").show();
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_OrcamentoConfirmado").show();
                        $grupo.find("#" + prefixo + "GrupoOpcaoOrcamento_OrcamentoConfirmado").prop('checked', situacaoAtual === 1);
                    }
                }
            });
        }
        $grupo.find(":hidden").remove();
    },

    esconderContainers: function () {
        $("[container]").hide();
        globalMU.removeProcessingToast()

        removerTodosComponentesReactDoConteudoPrincipal()
        removerBreadcrumb2()
    },

    renderizarViewCliente: async function () {

        if (!this.model) {
            return;
        }
        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="cliente"]').parent().addClass("ativo"); // FNX-1092

        this.esconderContainers();


        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesRegion",
                selector: "#pesquisar-clientes-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    model: this.model,
                    orcamentoController: this,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))

        this.mostrarValoresOrcamento();
        this.mostrarNomeCliente();



        // copiarEstadoReduxParaLegado()

    },

    renderizarViewClienteReact: async function () {

        if (!this.model) {
            return;
        }
        $("[item-menu]").parent().removeClass("ativo");
        //$('[item-menu="cliente-react"]').parent().addClass("ativo"); // FNX-1092
        $('[item-menu="cliente"]').parent().addClass("ativo"); // FNX-1092

        this.esconderContainers();


        removerBreadcrumbOriginal();

        renderizarComponentReact(<PesquisarClienteContainer regiaoRenderizada='conteudo-pagina' />, "conteudo-pagina", true)

        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento(); // 424268

    },

    renderizarViewDescontos: async function () {
        if (!this.model) {
            return;
        }

        if (this.model.get("CodigoCliente") <= 7) {
            this.renderizarViewCliente();
            global.showWarnMessage('É necessário selecionar o cliente antes de informar os descontos.');
            return;
        }

        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="descontos"]').parent().addClass("ativo");

        this.esconderContainers();

        this.descontosController = this.showView({
            region: {
                name: "descontosRegion",
                selector: "#descontos-region"
            },
            controller: {
                type: DescontosController,
                args: {
                    model: this.model,
                    orcamentoController: this,
                    readOnly: this.model.get("SomenteLeitura")
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewDescontosReact: async function () {


        if (!this.model) {
            return;
        }

        if (store.getState().orcamento.CodigoCliente <= 7) {
            this.renderizarViewClienteReact();
            global.showWarnMessage('É necessário selecionar o cliente antes de informar os descontos.');
            return;
        }

        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="descontos-react"]').parent().addClass("ativo");

        this.esconderContainers();

        renderizarComponentReact(<DescontosContainer />, "conteudo-pagina", true)

        // this.descontosController = this.showView({
        //     region: {
        //         name: "descontosRegion",
        //         selector: "#descontos-region"
        //     },
        //     react: {
        //         component: <DescontosContainer />,
        //         redux: true
        //     }
        // });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },


    selecionarFormaPagamentoCallback: function (cliente) {

        if (cliente) {
            this.model.set("FormaPagamento", cliente.get("Codigo"));
        }
    },

    limparFormaPagamentoCallback: function () {
        this.model.unset("CodigoCliente");
    },

    renderizarViewFormaPagamento: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        if (this.formaPagamentoController) {
            this.formaPagamentoController.dispose();
            delete this.formaPagamentoController;
        }

        this.formaPagamentoController = this.showView({
            region: {
                name: "formaPagamentoControllerRegion",
                selector: "#forma-pagamento-orcamento-region"
            },
            controller: {
                type: FormaPagamentoController,
                args: {
                    model: this.model,
                    orcamentoController: this,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarViewFormaPagamentoReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        renderizarComponentReact(<TelaFormaDePagamentoContainer
            somenteLeitura={store.getState().orcamento.SomenteLeitura || globalMU.isNotNullOrEmpty(store.getState().orcamento.CodigoDAV)} />, "conteudo-pagina", true)

        // this.showView({
        //     region: {
        //         name: "formaPagamentoControllerRegionReact",
        //         selector: "#forma-pagamento-orcamento-region"
        //     },
        //     react: {
        //         component: <TelaFormaDePagamentoContainer
        //             somenteLeitura={this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== ""}
        //         />,
        //         redux: true
        //     }
        // })
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento(); // 424268
    },

    renderizarViewComissoesReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        removerBreadcrumbOriginal();
        renderizarComponentReact(<TelaComissoesContainer />, "conteudo-pagina", true)

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false));
        this.mostrarValoresOrcamento();
    },

    renderizarViewEnderecosReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();
        removerBreadcrumbOriginal();
        renderizarComponentReact(<GridEnderecosContainer />, "conteudo-pagina", true)


        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento(); // 424268


    },

    renderizarViewItemVenda: async function () {

        if (!this.model) {
            return;
        }
        this.esconderContainers();

        const orcamento = store.getState().orcamento

        if ((orcamento.ItensOrcamento ?? []).length == 0) {
            renderizarComponentReact(<PaginaPesquisaProdutoContainer
                chamadoParaInserirProdutoNoOrcamento={true} // 491123
                chamadoPeloTrocarProduto={false}
                foraOrcamento={false}
                regiaoRenderizada='conteudo-pagina'
                onVoltar={() => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)}
                passos={new Dict<string, () => void>()
                    .set("Itens", () => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true))
                    .set("Pesquisar Produtos", () => { })}
            />, "conteudo-pagina", true)
        } else {
            renderizarComponentReact(<ItensOrcamentoContainer
                ehParaRenderizarPesquisaDeProdutosImediatamente={() => false}
            />, "conteudo-pagina", true)
        }



        // this.itemOrcamentoController = this.showView({
        //     region: {
        //         name: "itemOrcamentoRegion",
        //         selector: "#itens-orcamento-region"
        //     },
        //     controller: {
        //         type: ItemOrcamentoController,
        //         args: {
        //             model: this.model,
        //             orcamentoController: this,
        //             readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "",
        //             renderizarPesquisaDeProdutosImediatamente: store.getState().orcamento.OrcamentoExistenteSendoAbertoParaEdicaoOuConsulta ? false :
        //                 (store.getState().orcamento.ItensOrcamento ?? []).length > 0 ? false : true

        //         }
        //     }
        // });

        // this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },



    renderizarViewFinalizarOrcamento: async function () {
        // if (!this.model) {
        //     return;
        // }

        //if (!this.model.get("SomenteLeitura") && this.model.get("Situacao") !== 6 && this.model.get("Situacao") !== 1 && this.model.get("Situacao") !== 5) { // FNX-968
        //    global.showWarnMessage('É necessário selecionar o campo "Opções de Orçamento" antes de finalizar.');
        //    this.renderizarViewResumo();
        //    return;
        //} --- comentado - fnx-3304-fnx-3305


        //this.esconderContainers();

        // this.finalizarOrcamentoController = this.showView({
        //     region: {
        //         name: "finalizarOrcamentoControllerRegion",
        //         selector: "#finalizar-orcamento-region"
        //     },
        //     controller: {
        //         type: FinalizarOrcamentoController,
        //         args: {
        //             orcamento: this.model,
        //             orcamentoFinalizadoCallback: $.proxy(this.orcamentoFinalizado, this),
        //             readOnly: this.model.get("SomenteLeitura"),
        //             renderizarViewIndicadoresCallback: $.proxy(this.renderizarViewIndicadores, this)
        //         }
        //     }
        // });
        // this.habilitarTotais(false);
        // store.dispatch(totalizadorActions.desabilitarEdicoesAction(true))
        // this.mostrarValoresOrcamento();
    },

    renderizarViewDespesas: async function () { // 440122
        renderizarComponentReact(<DespesasOrcamentoContainer />, "conteudo-pagina", true) // 440122
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(true))
        this.mostrarValoresOrcamento();
    },

    renderizarViewFinalizarOrcamentoReact: async function () {
        // if (!this.model) {
        //     return;
        // }

        this.esconderContainers();

        renderizarComponentReact(<FinalizarOrcamentoContainer />, "conteudo-pagina", true)

        // this.showView({
        //     region: {
        //         name: "finalizarOrcamentoControllerRegion",
        //         selector: "#finalizar-orcamento-react-region"
        //     },
        //     react: {
        //         component: <FinalizarOrcamentoContainer />,
        //         redux: true
        //     }
        // });

        //this.habilitarTotais(false);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(true))
        this.mostrarValoresOrcamento();
    },

    renderizarViewEnderecos: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        this.enderecoOrcamentoController = this.showView({
            region: {
                name: "enderecoOrcamentoControllerRegion",
                selector: "#endereco-orcamento-region"
            },
            controller: {
                type: EnderecoOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarCotacoesPerdidas: async function () {
        if (!this.model) {
            return;
        }

        this.esconderContainers();

        this.pesquisarCotacoesPerdidasController = this.showView({
            region: {
                name: "pesquisarCotacoesPerdidasControllerRegion",
                selector: "#cotacoes-perdidas-orcamento-region"
            },
            controller: {
                type: PesquisarCotacoesPerdidasController,
                args: {
                    orcamento: this.model
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarCotacoesPerdidasReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        // this.showView({
        //     region: {
        //         name: "pesquisarCotacoesPerdidasControllerRegion",
        //         selector: "#cotacoes-perdidas-orcamento-region"
        //     },
        //     react: {
        //         component: <CotacoesPerdidasContainer regiaoRenderizada="cotacoes-perdidas-orcamento-region" />,
        //         redux: true
        //     }
        // });

        renderizarComponentReact(<CotacoesPerdidasContainer regiaoRenderizada="conteudo-pagina" />, "conteudo-pagina", true)

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarViewMarkup: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();



        this.markupOrcamentoController = this.showView({
            region: {
                name: "markupOrcamentoControllerRegion",
                selector: "#markup-orcamento-region"
            },
            controller: {
                type: MarkupOrcamentoController,
                args: {
                    orcamento: this.model
                }
            }
        });

        this.habilitarTotais(false);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },


    renderizarViewMarkupReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        renderizarComponentReact(<TelaMarkupContainer />, "conteudo-pagina", true)

        // this.showView({
        //     region: {
        //         name: "markupOrcamentoControllerRegion",
        //         selector: "#markup-orcamento-region"
        //     },
        //     react: {
        //         component: <TelaMarkupContainer/>,
        //         redux: true
        //     }
        // });

        //this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(true))
        this.mostrarValoresOrcamento();

    },

    renderizarViewIndicadores: async function (tabInicial) {

        if (!this.model) {
            return;
        }
        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="indicador-orcamento"]').parent().addClass("ativo");

        this.esconderContainers();


        this.indicadorOrcamentoController = this.showView({
            region: {
                name: "indicadorOrcamentoControllerRegion",
                selector: "#indicador-orcamento-region"
            },
            controller: {
                type: PesquisarIndicadorOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "", // fnx-968
                    tabInicial: tabInicial
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarViewAutorizadoOrcamento: async function () {

        if (!this.model) {
            return;
        }

        if (!this.model.get("SomenteLeitura") && this.model.get("CodigoCliente") <= 7) {
            this.renderizarViewCliente();
            global.showWarnMessage('É necessário selecionar o cliente antes de informar o autorizado.'); // FNX-1092
            return;
        }

        this.esconderContainers();


        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="autorizado-orcamento"]').parent().addClass("ativo");

        this.autorizadoOrcamentoController = this.showView({
            region: {
                name: "autorizadoOrcamentoControllerRegion",
                selector: "#autorizado-orcamento-region"
            },
            controller: {
                type: AutorizadoOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarViewAutorizadoOrcamentoReact: async function () {

        if (!store.getState().orcamento.SomenteLeitura && store.getState().orcamento.CodigoCliente <= 7) {
            this.renderizarViewClienteReact();
            global.showWarnMessage('É necessário selecionar o cliente antes de informar o autorizado.'); // FNX-1092
            return;
        }

        this.esconderContainers();


        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="autorizado-orcamento"]').parent().addClass("ativo");

        renderizarComponentReact(<AutorizadoContainer />, "conteudo-pagina", true)

        // this.autorizadoOrcamentoController = this.showView({
        //     region: {
        //         name: "autorizadoOrcamentoControllerRegion",
        //         selector: "#autorizado-orcamento-region"
        //     },
        //     react: {
        //         component: <AutorizadoContainer />,
        //         redux: true
        //     }
        // });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();

    },

    renderizarViewResumo: async function () {
        if (!this.model) {
            return;
        }

        console.log(this.model.attributes)

        $("[item-menu]").parent().removeClass("ativo");
        $('[item-menu="resumo-orcamento"]').parent().addClass("ativo");

        this.esconderContainers();


        this.resumoOrcamentoController = this.showView({
            region: {
                name: "resumoOrcamentoControllerRegion",
                selector: "#resumo-orcamento-region"
            },
            controller: {
                type: ResumoOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewResumoReact: async function () {

        this.esconderContainers();
        renderizarComponentReact(<ResumoOrcamentoContainer />, "conteudo-pagina", true)

        // this.showView({
        //     region: {
        //         name: "resumoOrcamentoControllerRegion",
        //         selector: "#resumo-orcamento-region"
        //     },
        //     react: {
        //         component: <ResumoOrcamentoContainer />,
        //         redux: true
        //     }
        // });
        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewEntregaOrcamento: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();


        this.entregaOrcamentoController = this.showView({
            region: {
                name: "entregaOrcamentoControllerRegion",
                selector: "#entrega-orcamento-region"
            },
            controller: {
                type: EntregaOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewEntregaOrcamentoReact: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();

        renderizarComponentReact(<TelaEntregaContainer />, "conteudo-pagina", true)


        // this.showView({
        //     region: {
        //         name: "entregaOrcamentoReact",
        //         selector:"#entrega-orcamento-react-region"
        //     },
        //     react: {
        //         component: <TelaEntregaContainer />,
        //         redux: true
        //     }
        // });

        //this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewFretePesoCubagem: async function () {

        if (!store.getState().orcamento.AptoParaGestaoDeFretes) {
            return
        }

        this.esconderContainers();

        // this.showView({
        //     region: {
        //         name: "fretePesoOuCubagemRegionReact",
        //         selector: "#frete-peso-cubagem-region-react"
        //     },
        //     react: {
        //         component: <FretePorPesoCubagemContainer />,
        //         redux: true
        //     }
        // })

        renderizarComponentReact(<FretePorPesoCubagemContainer />, "conteudo-pagina", true)

        this.habilitarTotais(true); // 424268
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false)) // 424268
        this.mostrarValoresOrcamento(); // 424268
    },

    renderizarViewFreteOrcamento: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();


        this.freteOrcamentoController = this.showView({
            region: {
                name: "freteOrcamentoControllerRegion",
                selector: "#frete-orcamento-region"
            },
            controller: {
                type: FreteOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },


    renderizarViewTipoEntregaOrcamento: async function () {

        if (!this.model) {
            return;
        }

        this.esconderContainers();


        this.tipoEntregaOrcamentoController = this.showView({
            region: {
                name: "tipoEntregaOrcamentoControllerRegion",
                selector: "#tipo-entrega-orcamento-region"
            },
            controller: {
                type: TipoEntregaOrcamentoController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarFaturamentoOutrasSaidas: async function () {
        if (!this.model) {
            return;
        }

        this.esconderContainers();


        this.faturamentoOutrasSaidasController = this.showView({
            region: {
                name: "faturamentoOutrasSaidasControllerRegion",
                selector: "#faturamento-outras-saidas-region"
            },
            controller: {
                type: faturamentoOutrasSaidasController,
                args: {
                    orcamento: this.model,
                    readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                }
            }
        });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarFaturamentoOutrasSaidasReact: async function () {
        if (!this.model) {
            return;
        }

        this.esconderContainers();

        renderizarComponentReact(<FaturamentoContainer orcamento={store.getState().orcamento} />, "conteudo-pagina", true)


        // this.showView({
        //     region: {
        //         name: "faturamentoOutrasSaidasControllerRegion",
        //         selector: "#faturamento-outras-saidas-region"
        //     },
        //     react: {
        //         component: <FaturamentoContainer orcamento={this.model.attributes} />,
        //         redux: false
        //     }

        // });

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },

    renderizarViewDestinoTransferenciaReact: async function () {
        if (!this.model) {
            return;
        }

        this.esconderContainers();

        renderizarComponentReact(<DestinoTransferenciaContainer />, "conteudo-pagina", true)

        this.habilitarTotais(true);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(false))
        this.mostrarValoresOrcamento();
    },


    orcamentoFinalizado: function () {
        this.habilitarTotais(false);
        store.dispatch(totalizadorActions.desabilitarEdicoesAction(true))
        this.mostrarValoresOrcamento(); // 424268
    },

    habilitarDespesasInclusas: function (habilitar) {

        var itens = this.model.get("ItensOrcamento");

        if (habilitar && (!itens || itens.length === 0)) {
            return;
        }

        $("#valor-despesas-inclusas").prop("disabled", !habilitar);
    },

    habilitarAcrescimoFinanceiro: function (habilitar) {

        var itens = this.model.get("ItensOrcamento");

        if (habilitar && (!itens || itens.length === 0)) {
            return;
        }

        $("#valor-acrescimo-financeiro").prop("disabled", !habilitar);
    },

    habilitarDescontos: function (habilitar) {

        var itens = this.model.get("ItensOrcamento");

        if (habilitar && (!itens || itens.length === 0)) {
            return;
        }
        // valor desconto
        if (!$("#valor-desconto").hasAttr("allowEnable") || $("#valor-desconto").attr("allowEnable") === true) {
            $("#valor-desconto").prop("disabled", !habilitar);
        }
        if (!$("#valor-desconto-nacional").hasAttr("allowEnable") || $("#valor-desconto-nacional").attr("allowEnable") === true) {
            $("#valor-desconto-nacional").prop("disabled", (habilitar && this.model.attributes.ValorTotalMercadoriasNacionais <= 0) || !habilitar); /*FNX-5558*/
        }
        if (!$("#valor-desconto-importado").hasAttr("allowEnable") || $("#valor-desconto-importado").attr("allowEnable") === true) {
            $("#valor-desconto-importado").prop("disabled", (habilitar && this.model.attributes.ValorTotalMercadoriasImportadas <= 0) || !habilitar); /*FNX-5558*/
        }


        // percentual desconto
        if (!$("#percentual-desconto").hasAttr("allowEnable") || $("#percentual-desconto").attr("allowEnable") === true) {
            $("#percentual-desconto").prop("disabled", !habilitar);
        }
        if (!$("#percentual-desconto-nacional").hasAttr("allowEnable") || $("#percentual-desconto-nacional").attr("allowEnable") === true) {
            $("#percentual-desconto-nacional").prop("disabled", (habilitar && this.model.attributes.ValorTotalMercadoriasNacionais <= 0) || !habilitar); /*FNX-5558*/
        }
        if (!$("#percentual-desconto-importadov").hasAttr("allowEnable") || $("#percentual-desconto-importado").attr("allowEnable") === true) {
            $("#percentual-desconto-importado").prop("disabled", (habilitar && this.model.attributes.ValorTotalMercadoriasImportadas <= 0) || !habilitar); /*FNX-5558*/
        }


        //
        if (!$("#valor-desconto-acumulado").hasAttr("allowEnable") || $("#valor-desconto-acumulado").attr("allowEnable") === true) {
            $("#valor-desconto-acumulado").prop("disabled", !habilitar);
        }

        if (!$("#percentual-desconto-acumulado").hasAttr("allowEnable") || $("#percentual-desconto-acumulado").attr("allowEnable") === true) {
            $("#percentual-desconto-acumulado").prop("disabled", !habilitar);
        }
    },


    mostrarValoresOrcamento: function () {
        $("#menu-consulta-produtos").hide();
        $("#menu-sub-consulta-produtos").hide();
        AsideDireita.show("valores-orcamento");
    },

    mostrarNomeCliente: function () {
        const orcamento = store.getState().orcamento

        if (orcamento.TipoOrcamento !== 2) {
            var $infAdicOrc = $("#informacaoAdicionalOrcamento");
            if ($infAdicOrc !== undefined) {
                $infAdicOrc.show();

                $infAdicOrc.text(orcamento.NomeCliente)

            }
        }
    },

    atualizarTotais: function () {
        // if (!this.model.get("AtualizandoOrcamentoViaJS"))  // FNX-4826
        // {
        //     var valorTotalMercadorias = this.model.get("ValorTotalMercadorias");
        //     var quantidadeItens = this.model.get("ItensOrcamento") ? this.model.get("ItensOrcamento").length : 0;

        //     var descontoIcms = this.model.get('ValorDescontoIcms')/*FNX-4794*/
        //     if (descontoIcms === null) { $("#Totalizacao_ValorDescontoIcmsOrcamento").hide();/*FNX-4794*/ }
        //     else {
        //         //$("#valor-Desconto-icms").html(global.formatMoney(descontoIcms)); /*FNX-4794*/
        //         $("#valor-Desconto-icms").val(global.formatNumber(descontoIcms));/*FNX-4794*/
        //         $("#Totalizacao_ValorDescontoIcmsOrcamento").show();/*FNX-4794*/
        //     }

        //     $("#quantidade-itens-orcamento").html(quantidadeItens);
        //     $("#valor-total-mercadorias-orcamento").html(global.formatMoney(valorTotalMercadorias));
        //     $("#valor-total-mercadorias-nacionais-orcamento").html(global.formatMoney(this.model.attributes.ValorTotalMercadoriasNacionais)); /*FNX-5558*/
        //     $("#valor-total-mercadorias-importadas-orcamento").html(global.formatMoney(this.model.attributes.ValorTotalMercadoriasImportadas)); /*FNX-5558*/
        //     $("#percentual-desconto-nacional").val(global.formatMoney(this.model.attributes.PercentualDescontoSobreMercadoriasNacionais)); /*FNX-5558*/
        //     $("#valor-desconto-nacional").val(global.formatMoney(this.model.attributes.ValorDescontoSobreMercadoriasNacionais)); /*FNX-5558*/
        //     $("#percentual-desconto-importado").val(global.formatMoney(this.model.attributes.PercentualDescontoSobreMercadoriasImportadas)); /*FNX-5558*/
        //     $("#valor-desconto-importado").val(global.formatMoney(this.model.attributes.ValorDescontoSobreMercadoriasImportadas)); /*FNX-5558*/


        //     $("#valor-despesas-inclusas").val(global.formatNumber(this.model.get("ValorDespesasInclusas")));
        //     $("#valor-acrescimo-financeiro").val(global.formatNumber(this.model.get("ValorAcrescimoFinanceiro")));
        //     $("#valor-substituicao").val(global.formatNumber(this.model.get("ValorSubstituicao")));
        //     $("#valor-ipi").val(global.formatNumber(this.model.get("ValorIPI")));
        //     $("#percentual-seguro-entrega").val(global.formatNumber(this.model.get("PercentualSeguroEntrega")));
        //     $("#valor-seguro-entrega").val(global.formatNumber(this.model.get("ValorSeguroEntrega")));
        //     $("#valor-frete").val(global.formatNumber(this.model.get("ValorFrete")));
        //     $("#valor-total-orcamento").html(global.formatMoney(this.model.get("ValorTotal")));
        //     $("#valor-total-solicitado-orcamento").html(global.formatMoney(this.model.get("ValorTotalSolicitado")));
        //     $("#valor-total-pendente-orcamento").html(global.formatMoney(this.model.get("ValorTotalPendente")));

        //     if ($("#detalhe-resumo-orcamento-region").is(":visible")) {
        //         this.renderizarViewResumo(); //FNX-807
        //     }

        //     if ($("#detalhe-finalizar-orcamento-region").is(":visible")) {
        //         this.renderizarViewFinalizarOrcamento();
        //     }

        //     if (this.model.itemMenu === "indicador-orcamento") {
        //         this.renderizarViewIndicadores() // FNX-5597
        //     }

        //     var habilitar = valorTotalMercadorias && valorTotalMercadorias > 0;

        //     this.habilitarTotais(habilitar);
        // }
    },

    habilitarTotais: function (habilitar) {

        // habilitar = habilitar && (!this.model.get("SomenteLeitura") && this.model.get("CodigoDAV") === "");

        // this.habilitarDespesasInclusas(habilitar);
        // this.habilitarDescontos(habilitar);
        // this.habilitarAcrescimoFinanceiro(habilitar);

        // $("#percentual-seguro-entrega").prop("disabled", !habilitar);
        // $("#valor-seguro-entrega").prop("disabled", !habilitar || this.model.get("PercentualSeguroEntrega") > 0);
        // $("#valor-frete").prop("disabled", !habilitar);

        // if (habilitar) { // Fnx-5558 --- 0 = Por Valor. 1=PorPercentual; -1 = indefiniro
        //     $("#percentual-desconto-nacional").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 0 || this.model.attributes.ValorTotalMercadoriasNacionais <= 0);
        //     $("#percentual-desconto-importado").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 0 || this.model.attributes.ValorTotalMercadoriasImportadas <= 0);
        //     $("#percentual-desconto").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 0);

        //     $("#valor-desconto-nacional").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 1 || this.model.attributes.ValorTotalMercadoriasNacionais <= 0);
        //     $("#valor-desconto-importado").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 1 || this.model.attributes.ValorTotalMercadoriasImportadas <= 0);
        //     $("#valor-desconto").prop("disabled", this.model.attributes.TipoTratamentoDesconto === 1);
        // }

        // if (habilitar && this.model.attributes.TipoTratamentoDesconto === -1 && parametroSistema.obter("APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO").Valor === "S" && parametroSistema.obter("DESCONTO_ACUMULADO").Valor === "S") // manut-21
        // {
        //     $("#valor-desconto").prop("disabled", true);
        //     $("#percentual-desconto").prop("disabled", true);
        //     $("#valor-desconto-acumulado").prop("disabled", true);
        // }

    },

    atualizarDescontos: function () {
        // if (!this.model.get("AtualizarRemoto")) {
        //     return; // FNX-4579; FNX-4604; FNX-4637 - Performance
        // }

        // $("#percentual-desconto").val(global.formatNumber(this.model.get("PercentualDesconto")));
        // $("#valor-desconto").val(global.formatNumber(this.model.get("ValorDesconto")));
        // $("#percentual-desconto-acumulado").val(global.formatNumber(this.model.get("PercentualDescontoAcumulado")));
        // $("#valor-desconto-acumulado").val(global.formatNumber(this.model.get("DescontoAcumulado")));


        /**
         * esta chamada foi removida propositalmente pois foi constatado usando
         * a ferramenta de performance do chrome dev tols que outros pontos do código durante a atualização
         * dos itens do orçamento já chamavam esta função de atualização de itens
         *
         * jonathan bispo - 2020-02-28
         */
        //this.atualizarItens();

        // este código foi explicitamente removido para corrigir o problema relatado na FNX-5450 após modificações da FNX-5438
        // existe um comentário na FNX 5450 de 23/10/2020 que explica melhor, mas em resumo, após editar o campo pedido de compra,
        // uma série de efeitos colaterais fazia o código cair neste trecho e colocava o foco no botão de edição

        // if (this.itemOrcamentoController) {

        //     // this.itemOrcamentoController.posicionarCursorEdicao(); // FNX-4970-FNX-4893
        // }

    },

    atualizarItens: function () {
        global.blockUI()
        if (this.itemOrcamentoController) {
            //this.itemOrcamentoController.atualizar();
        }
        global.unblockUI()
    },

    //@Deprecated
    definirDespesasInclusas: async function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var val = $(e.target).val();

        var valorDespesasInclusas = val ? val.replace("R", "").replace("$", "") : 0;

        if (valorDespesasInclusas === "")
            valorDespesasInclusas = 0;

        // this.model.set("ValorDespesasInclusas", valorDespesasInclusas);

        await definirDespesasInclusas({
            valorDespesasInclusas
        })


    },

    percentualDescontoNacionalAlterado: function (iskeypress, e) { // FNX-5558

        if (iskeypress && e.which !== 13) {
            return;
        }
        var percentual = $(e.target).val();
        if (!percentual) {
            percentual = 0;
        }
        this.model.set("PercentualDescontoSobreMercadoriasNacionais", percentual);
    },

    percentualDescontoImportadoAlterado: function (iskeypress, e) { // FNX-5558

        if (iskeypress && e.which !== 13) {
            return;
        }
        var percentual = $(e.target).val();
        if (!percentual) {
            percentual = 0;
        }

        this.model.set("PercentualDescontoSobreMercadoriasImportadas", percentual);
    },

    percentualDescontoAlterado: function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var percentual = $(e.target).val();

        if (!percentual) {
            percentual = 0;
        }


        this.model.set("PercentualDesconto", percentual);
    },

    percentualDescontoAcumuladoAlterado: async function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var percentual = $(e.target).val();

        if (!percentual) {
            percentual = 0;
        }

        // this.model.set("PercentualDescontoAcumulado", percentual);

        await definirPercentualDescontoAcumulado({
            percentualDescontoAcumulado: percentual
        })
    },

    valorDescontoNacionalAlterado: function (iskeypress, e) { // FNX-5558

        if (iskeypress && e.which !== 13) {
            return;
        }
        var valor = $(e.target).val();
        if (!valor) {
            valor = 0;
        }
        this.model.set("ValorDescontoSobreMercadoriasNacionais", valor);
    },

    valorDescontoImportadoAlterado: function (iskeypress, e) { // FNX-5558

        if (iskeypress && e.which !== 13) {
            return;
        }
        var valor = $(e.target).val();
        if (!valor) {
            valor = 0;
        }
        this.model.set("ValorDescontoSobreMercadoriasImportadas", valor);
    },

    valorDescontoAlterado: function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }

        this.model.set("ValorDesconto", valor);
    },

    valorDescontoAcumuladoAlterado: function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }


        //this.model.set("ValorDescontoAcumulado", valor);
        //store.dispatch(sobrescreverInformacoesAction({DescontoAcumulado: valor}))
    },

    valorAcrescimoFinanceiroAlterado: function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }

        this.model.set("ValorAcrescimoFinanceiro", valor);

    },

    //@Deprecated
    percentualSeguroAlterado: async function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }

        // this.model.set("PercentualSeguroEntrega", valor);

        await definirPercentualSeguroEntrega({
            percentualSeguroEntrega: valor
        })

    },

    valorSeguroAlterado: async function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }

        // this.model.set("ValorSeguroEntrega", valor);

        await definirValorSeguroEntrega({
            valorSeguroEntrega: valor
        })

    },

    valorFreteAlterado: async function (iskeypress, e) {

        if (iskeypress && e.which !== 13) {
            return;
        }

        var valor = $(e.target).val();

        if (!valor) {
            valor = 0;
        }

        // this.model.set("ValorFrete", valor);

        await definirValorFrete({
            valorFrete: valor
        })

        if ($("#entrega-orcamento-region").is(":visible")) { // FNX-4815
            this.renderizarViewEntregaOrcamento();
        }
    },
});

window.OrcamentoController = OrcamentoController

export {
    OrcamentoController
}
